import { combineReducers } from 'redux';
import adjustmentReducer from './adjustment';
import purchaseOrderReducer from './purchaseOrder';
import summaryReducer from './summary';
import supplierReducer from './supplier';
import transferReducer from './transfer';
import ingredientSubscriptionReducer from './ingredientSubscription';

export {
  adjustmentReducer,
  purchaseOrderReducer,
  summaryReducer,
  supplierReducer,
  transferReducer,
  ingredientSubscriptionReducer,
};

export default combineReducers({
  summary: summaryReducer,
  supplier: supplierReducer,
  purchaseOrder: purchaseOrderReducer,
  transfer: transferReducer,
  adjustment: adjustmentReducer,
  ingredientSubscription: ingredientSubscriptionReducer,
});
